<div class="form-field" [formGroup]='parent' style="display: none;"
  [attr.aria-describedBy]="'lbl-'+pageName+'-'+controllerData.controlName">
  <label [id]="'lbl-'+pageName+'-'+controllerData.controlName" [attr.for]="pageName+'-'+controllerData.controlName"
  class="form-label">{{controllerData['label']}}</label>
  <input [formControlName]="controllerData['controlName']" [name]="controllerData['name']" aria-required="true"
    type="hidden" [id]="pageName+'-'+controllerData['name']" [(ngModel)]="textValue"
    [placeholder]="controllerData['placeHolder']" maxlength="14" class="form-control"
    [ngClass]=" (router.url !== '/quote/your-product-options') ? 'modalClose-focus' : '' " [value]="textValue"
    [required]="controllerData['required']"
    [attr.aria-describedBy]="'input-'+pageName+'-'+controllerData.controlName" inputmode="numeric" />
  </div>

  <form [formGroup]="selectForm">
    <div class="form-group">
      @if (!allowFutureDate) {
        <div>
          <label [id]="'lbl-'+pageName+'-'+controllerData.controlName" [attr.for]="pageName+'-'+controllerData.controlName"
          class="form-label">{{controllerData['label']}}</label>
        </div>
      }

      <div [ngClass]="allowFutureDate? 'col-md-12 clear-all mar-pad-0':'col-md-12 calender-container'">
        <div [ngClass]="allowFutureDate? 'col-md-12 clear-all flex-container mini-gap  ':'col-md-12 clear-all flex-container'">
          <div class="form-field flex-30">
            <div class="form-field-select">
              <select id="day"
                [ngClass]="{'invalid-error-border': (parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected))}"
                class="form-control fixed-width" aria-required="true" [required]="true"
                [attr.aria-invalid]="(parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected)) ? true : false"
                formControlName="day" [(ngModel)]="selectedDay" (change)="onChangeOfDropdown($event)"
                (blur)="onChangeOfDropdown($event)">
                <option [ngValue]="null" [disabled]="false">Day</option>
                @for (day of days; track day; let i = $index) {
                  <option [id]="i+1" [value]="i+1">{{ day }}</option>
                }
              </select>
              <i class="icon icon-chevron-down" aria-hidden="true"></i>
            </div>
          </div>
          <div class="form-field flex-40">
            <div class="form-field-select">
              <select id="month"
                [ngClass]="{'invalid-error-border': (parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected))}"
                class="form-control fixed-width" aria-required="true" [required]="true"
                [attr.aria-invalid]="(parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected)) ? true : false"
                formControlName="month" [(ngModel)]="selectedMonth" (change)="onChangeOfDropdown($event)"
                (blur)="onChangeOfDropdown($event)">
                <option [ngValue]="null" [disabled]="false">Month</option>
                @for (month of months; track month; let i = $index) {
                  <option [id]="i + 1" [value]="i + 1">{{ month }}
                  </option>
                }
              </select>
              <i class="icon icon-chevron-down" aria-hidden="true"></i>
            </div>
          </div>

          <div class="form-field flex-30">
            <div class="form-field-select">
              <select id="year"
                [ngClass]="{'invalid-error-border': (parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected))}"
                class="form-control fixed-width" aria-required="true" [required]="true"
                [attr.aria-invalid]="(parent.get(controllerData.controlName).touched && (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors || !isValidDateSelected)) ? true : false"
                formControlName="year" [(ngModel)]="selectedYear" (change)="onChangeOfDropdown($event)"
                (blur)="onChangeOfDropdown($event)">
                <option [ngValue]="null" [disabled]="false">Year</option>
                @for (year of years; track year; let i = $index) {
                  <option [id]="year" [value]="year">{{ year }}
                  </option>
                }
              </select>
              <i class="icon icon-chevron-down" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      @if (parent.get(controllerData.controlName).touched &&
        (selectForm.get('day').errors || selectForm.get('month').errors || selectForm.get('year').errors  || !isValidDateSelected)) {
        <div class="form-validation-error"
          >
          <i class="icon icon-error" aria-hidden="true"></i>
          @if ( !(allowFutureDate && isStartDateThreeMonthsError) || isInvalidDate) {
            <p [id]="controlName +'-error'">
              {{"Please enter a valid date"}}
            </p>
          }
          @if (allowFutureDate && isStartDateThreeMonthsError && !isInvalidDate) {
            <p [id]="controlName +'-error'">
              {{controllerData['StartDateThreeMonthsError']}}
            </p>
          }
        </div>
      }
    </div>
  </form>